const ProgressBar = ({ currentTime = 0, duration = 225, className = "" }) => {
  
  const progressWidth = Math.min((currentTime / duration) * 100, 100);

  return (
    <div className={`bg-hover-charcoal rounded-full ${className}`}>
      <div
        className="bg-white h-[4px] rounded-full"
        style={{ width: `${progressWidth}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;